import { useState } from "react";
import { Card, SectionHeader } from "../../components/lib";
import { ListRow, Drawer, Field } from "../../components/lib.overlay";
import { AI_CONVERSATIONS, AI_TEAMMATES, AiConversation } from "../../mocks/aiData";

function teammate(id: string) { return AI_TEAMMATES.find((t) => t.id === id); }

export default function Conversations() {
  const [selected, setSelected] = useState<AiConversation | null>(null);
  return (
    <div className="space-y-6" data-testid="ai-conversations">
      <Card padded={false} testId="ai-co-list">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}><SectionHeader eyebrow="Conversations" title={`${AI_CONVERSATIONS.length} chats`} /></div>
        <div className="p-2">
          {AI_CONVERSATIONS.map((c) => {
            const t = teammate(c.teammateId);
            return (
              <ListRow key={c.id} testId={`ai-co-${c.id}`} onClick={() => setSelected(c)}
                label={c.title}
                sublabel={<>{t?.name} · {c.askedBy} · {c.askedRelative} · {c.messages} msgs · {c.decisions} decisions</>}
              />
            );
          })}
        </div>
      </Card>

      <Drawer open={Boolean(selected)} onClose={() => setSelected(null)} title="Conversation" testId="ai-co-drawer" width={520}>
        {selected && (
          <div>
            <div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ai)" }}>{teammate(selected.teammateId)?.title}</div>
            <div style={{ fontFamily: "var(--ph-display-font)", fontSize: "1.2rem", color: "var(--ph-ink-strong)" }} className="mt-1 mb-3">{selected.title}</div>
            <Field label="Asked by" inline><span className="text-sm">{selected.askedBy}</span></Field>
            <Field label="When" inline><span className="text-sm">{selected.askedRelative}</span></Field>
            <Field label="Messages" inline><span className="text-sm tabular-nums">{selected.messages}</span></Field>
            <Field label="Decisions" inline><span className="text-sm tabular-nums">{selected.decisions}</span></Field>
            <div className="pt-3">
              <div className="text-[10px] uppercase tracking-[0.14em] mb-1.5" style={{ color: "var(--ph-ink-muted)" }}>Summary</div>
              <div className="text-sm p-3" style={{ background: "var(--ph-surface)", borderRadius: "var(--ph-radius-md)", color: "var(--ph-ink-default)" }}>{selected.summary}</div>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
}
